(function () {
  var DistanceColumnGenerator = function (batchGeoTable) {
    var generateColumn = function () {
      var mapsManager = window.batchGeoGoogleMapsManager;
      var distanceMarkerPosition =
        BatchGeoStore.getState().MarkerMeasure.position;
      var mapRS = batchGeoTable.options.data.mapRS;

      batchGeoTable.addColumn(
        "Distance",
        mapRS.map(function (row) {
          var distance = mapsManager.getDistanceBetweenMarkers(
            new google.maps.LatLng(row.lt, row.ln),
            distanceMarkerPosition,
          );
          return distance + " " + mapsManager.getDistanceScale();
        }),
        batchGeoTable.data.columns.length,
      );

      batchGeoTable.render();
      window.batchGeoTableMap.updateTableHeight();
    };

    var removeColumn = function () {
      var distanceColumnIndex = batchGeoTable.data.columns.indexOf("Distance");
      batchGeoTable.removeColumn(distanceColumnIndex);
      batchGeoTable.render();
      window.batchGeoTableMap.updateTableHeight();
    };

    return {
      generateColumn: generateColumn,
      removeColumn: removeColumn,
    };
  };

  window.DistanceColumnGenerator = DistanceColumnGenerator;
})();
